/*       */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { bind } from 'app/utils/decorators/decoratorUtils';

import Sidebar from 'app/components/templates/Sidebar';
import { DEFAULT_RIGHT_SIDEBAR_WIDTH, MIN_RIGHT_SIDEBAR_WIDTH } from 'app/config/config';
import { resizeSidebar, setOnBack } from 'store/actions/sidebar/sidebarActions';

class FiltersInternalSidebar extends PureComponent {
    static propTypes = {
        title: PropTypes.string,
        subTitle: PropTypes.string,
        actions: PropTypes.any,
        content: PropTypes.any,
        isOpen: PropTypes.bool,
        expanded: PropTypes.bool,
        isMobile: PropTypes.bool,
    };

    constructor(props) {
        super(props);
        this.state = {
            sidebarWidth: DEFAULT_RIGHT_SIDEBAR_WIDTH,
        };
    }

    @bind
    handleResize(width) {
        this.setState((state) => ({
            sidebarWidth: width,
        }));
    }

    render() {
        const { options, closeSidebar, resizeSidebar, isMobile } = this.props;
        const { title, isOpen, subTitle, subTitleRight, actions, content, expanded, onBack, afterCloseSidebar, iconName, iconType } = options || {};
        const { sidebarWidth } = this.state;
        
        return (
            isOpen && <section id="global-right-panel">
                <Sidebar
                    iconName={iconName}
                    iconType={iconType}
                    handleHorizonalScoll={this.props.handleHorizonalScoll}
                    activeSidebar={'filter'}
                    isMobile={isMobile}
                    fullScreen={expanded}
                    onClose={closeSidebar}
                    afterCloseSidebar={afterCloseSidebar}
                    onBack={onBack}
                    isResizing={resizeSidebar}
                    sidebarWidth={sidebarWidth}
                    onResize={this.handleResize}
                    title={title}
                    subTitle={subTitle}
                    subTitleRight={subTitleRight}
                    className={`global-template-sidebar sidebar-type-filter`}
                    actions={actions}
                    minSidebarWidth={MIN_RIGHT_SIDEBAR_WIDTH}
                    defaultSidebarWidth={DEFAULT_RIGHT_SIDEBAR_WIDTH}
                >
                    {content}
                </Sidebar>
            </section>
        );
    }
}

export default connect(
    (state, ownProps) => {
        return {
            isMobile: state.global.isMobile,
            handleHorizonalScoll: state.sidebar.handleHorizonalScoll,
        };
    },
    {  resizeSidebar, setOnBack }
)(withRouter(FiltersInternalSidebar));
